import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { PrimaryLayout } from '@/layouts/primary';
import { Text } from '@mantine/core';
import { IconMailOpened } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';

export const PasswordLinkSentPage = () => {
	const navigate = useNavigate();
	const backToLogin = useCallback(() => navigate({ to: '/auth/login' }), [navigate]);
	const backToLoginButton = useMemo(
		() => <StandardButton onClick={backToLogin}>Back to Login</StandardButton>,
		[backToLogin]
	);

	return (
		<PrimaryLayout footer={{ children: backToLoginButton }}>
			<ContentPanel gap="md" justify="center" align="center" flex={1}>
				<IconMailOpened size={32} />
				<Text ta="center" size="lg" fw={900}>
					Password Link Sent
				</Text>

				<Text ta="center" size="sm" fw={400}>
					Check your email inbox and spam for a link to reset your password.
				</Text>
			</ContentPanel>
		</PrimaryLayout>
	);
};
